import { Image } from '@sitecore-jss/sitecore-jss-react';
import styles from './OffersHero.module.scss';

export default function OffersHero({ heroTitle, heroImage }) {
  const hasValidImage =
    heroImage &&
    (heroImage.fields?.desktopImage?.value?.src ||
      heroImage.fields?.tabletImage?.value?.src ||
      heroImage.fields?.mobileImage?.value?.src);

  return (
    <div className={styles.wrapper} data-aos="fade-up">
      {hasValidImage ? (
        <Image field={heroImage.fields.desktopImage} className={styles.backgroundImage} />
      ) : (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: '#f0f0f0',
            borderRadius: '20px',
            zIndex: -1,
          }}
        />
      )}
      <h1 className={styles.title}>{heroTitle || 'Offers'}</h1>
    </div>
  );
}
